<template>
  <div id="app">

    <!-- <div id="border"></div> -->
    <HomeScreen class='home-screen' v-if="isHidden"/>
    <div id="settings-locator" ></div>

    <div class="container">
      <!-- <div style="position:absolute;top:300px;left:0;width:600px;height:400px;background:white;z-index: 1000;">
        <iframe src="./wires_animate_test/" width="800" height="600" scrolling="no" frameBorder="0"></iframe>
      </div> -->
      <HeadsUpDisplay class='uicontainer'/>

      <div id="animation_container" v-bind:class="{ hidden: isHidden }">
        <canvas id="canvas" width="800" height="1200" style="position: absolute; display: block; background-color:rgba(255, 255, 255, 0);"></canvas>
        <div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:800px; height:1200px; position: absolute; left: 0px; top: 0px; display: block;">
        </div>
      </div>
      <div id='_preload_div_'><img src='images/_preloader.gif'/></div>

    </div>
    <div id="backGrad" v-bind:class="{ hidden: isHidden }"></div>

  </div>
</template>

<script>
import HomeScreen from './components/HomeScreen.vue'
import HeadsUpDisplay from './components/HeadsUpDisplay.vue'

export default {
  name: 'App',
  components: {
    HomeScreen,
    HeadsUpDisplay
  },
  data() {
      return {
        comic: [],
        sRatio: .5,
        isHidden: false
      }
    },
    beforeMount() {

      window.appRoot = this; // reference so canvas calls can find Vue functions

      const urlParams = new URLSearchParams(window.location.search);
      let hhParam = urlParams.get('hh');

      if(hhParam == null){ hhParam = '1'; }

      let hhScript = document.createElement('script')
      hhScript.setAttribute('src', 'js/pages/page' + hhParam+ '.js')
      let hhsetScript = document.createElement('script')
      hhsetScript.setAttribute('src', 'js/settings.js')
      document.head.appendChild(hhScript)
      document.head.appendChild(hhsetScript)
      

    },
    mounted() {


      parent.repositionIframe();

      // window.appRoot = this; // reference so canvas calls can find Vue functions

      // const urlParams = new URLSearchParams(window.location.search);
      // let hhParam = urlParams.get('hh');

      // if(hhParam == null){ hhParam = '1'; }

      // let hhScript = document.createElement('script')
      // hhScript.setAttribute('src', 'js/pages/page' + hhParam+ '.js')
      // let hhsetScript = document.createElement('script')
      // hhsetScript.setAttribute('src', 'js/settings.js')
      // document.head.appendChild(hhScript)
      // document.head.appendChild(hhsetScript)

      gsap.fromTo('#_preload_div_', 3, {alpha:0,delay:2},{alpha:1,ease:Power2.easeInOut})

    },
    methods: {
      showHomeFN: function(){
        this.isHidden = true
      },
      hideHomeFN: function(){
        this.isHidden = false
        playPageOne()
      }
    }
}
</script>

<style lang="scss">

.hidden {
  opacity: 0;
}

// #border{
//   width: calc(100vw - 20px);
//   height: calc(50vh - 19px);
//   position: absolute;
//   top: 25vh;
//   left: 0;
//   border: 10px solid black;
//   z-index: 9999;
//   pointer-events:none;
//   @media only screen and (max-width: 660px) {
//     width: calc(100vw - 20px);
//     height: calc(100vh - 19px);
//     top: 0;
//   }
// }

#app {
  font-family: "Comic Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#backGrad{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		pointer-events:none;
		background: linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.25) 25%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.25) 75%, rgba(0,0,0,0.4) 100%);
	}

.uicontainer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  // border: 1px solid red;
  opacity: .9;

  @media only screen and (max-width: 660px) {
    bottom:0;
  }
}

.home-screen{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 25%;
  left: 0;
  z-index: 999;
}

// @media only screen and (max-width: 799px) {
//   .home-screen {
//     top: 0;
//   }
// }

body.mobile .home-screen {
  top: 0;
}

#_preload_div_ {
  position:absolute;
  top:45vh;
  left:0;
  display: inline-block;
  height: 100vh;
  width: 95vw;
  text-align: center;
}

#_preload_div_ img{
  height: 10vh;
}













  .speech-bubble{
  --arrow-w:0.5em;
  --arrow-h:1em;
  --bubble-corners:0;
  --w:12em;
  --w-mob: 12em;
  --border-size:3px;
  --text-color:black;
  --bubble-color:white;
  --border-color:black;
}
.speech-bubble{
  text-align:center;
  font-family: "Comic Neue", cursive;
  font-size: 1rem;
  font-weight:bold;
  color:var(--text-color);
  background:var(--bubble-color);
  padding: 0.75em 1em;
  position:relative;
  border-radius:var(--bubble-corners);
  max-width:var(--w);
  box-shadow:0 0 0 var(--border-size) var(--border-color);
  // @media only screen and (max-width: 799px) {
  //   width: var(--w-mob);
  //   max-width: none;
  // }
}

body.mobile .speech-bubble {
  width: var(--w-mob);
  max-width: none;
}

.speech-bubble.round{
  --bubble-corners:1em;
}

.speech-bubble.circle{
  --bubble-corners:100%;
  padding:2em;
}

.speech-bubble:before,.speech-bubble:after{
  content:"";
  position:absolute;
  bottom:calc(-1 * var(--arrow-h) * 2 + 0.5px);
  bottom:calc(-1 * var(--arrow-h) * 2 + 0.5*var(--border-size));
  left:50%;
  border-style:solid;
  border-width:var(--arrow-h) var(--arrow-w);
  border-color:var(--bubble-color) transparent transparent;
}

.speech-bubble:before{
  border-width:calc(var(--arrow-h) + var(--border-size)) calc(var(--arrow-w) + var(--border-size));
  border-color:var(--border-color) transparent transparent;
  bottom:calc(-1 * var(--arrow-h) * 2 - 2.5*var(--border-size));
  left:calc(50% - var(--border-size));
}

// @media only screen and (max-width: 799px) {

//   .speech-bubble.left:before {
//     left:calc(25% - var(--border-size));
//   }
//   .speech-bubble.left:after {
//     left: 25%;
//   }

//   .speech-bubble.right:before {
//     left:calc(75% - var(--border-size));
//   }
//   .speech-bubble.right:after {
//     left: 75%;
//   }
// }

body.mobile .speech-bubble.left:before {
    left:calc(25% - var(--border-size));
  }
body.mobile .speech-bubble.left:after {
    left: 25%;
  }

body.mobile .speech-bubble.right:before {
    left:calc(75% - var(--border-size));
  }
body.mobile .speech-bubble.right:after {
    left: 75%;
  }

.speech-bubble.t:after{
  border-color:transparent transparent var(--bubble-color);
  bottom:auto;
  top:calc(-1 * var(--arrow-h) * 2 + 1.5px);
}

.speech-bubble.t:before{
  border-width:calc(var(--arrow-h) + var(--border-size)) calc(var(--arrow-w) + var(--border-size));
  border-color:transparent transparent var(--border-color);
  bottom:auto;
  top:calc(-1 * var(--arrow-h) * 2 - 2.5*var(--border-size));
}

.speech-bubble.l:after{
  border-color:transparent var(--bubble-color) transparent transparent;
  bottom:auto;
  border-width:var(--arrow-w) var(--arrow-h);
  top:calc(50% - var(--arrow-w));
  left:calc(-1 * var(--arrow-h) * 2 + 0.5px);
}

.speech-bubble.l:before{
  border-width:calc(var(--arrow-w) + var(--border-size)) calc(var(--arrow-h) + var(--border-size));
  border-color:transparent var(--border-color) transparent transparent;
  bottom:auto;
  top:calc(50% - var(--arrow-w) - var(--border-size));
  left:calc(-1 * var(--arrow-h) * 2 - 2.5*var(--border-size));
}

.speech-bubble.r:after{
  border-color:transparent transparent transparent var(--bubble-color);
  bottom:auto;
  left:auto;
  border-width:var(--arrow-w) var(--arrow-h);
  top:calc(50% - var(--arrow-w));
  right:calc(-1 * var(--arrow-h) * 2 + 0.5px);
}

.speech-bubble.r:before{
  border-width:calc(var(--arrow-w) + var(--border-size)) calc(var(--arrow-h) + var(--border-size));
  border-color:transparent transparent transparent var(--border-color);
  bottom:auto;
  left:auto;
  top:calc(50% - var(--arrow-w) - var(--border-size));
  right:calc(-1 * var(--arrow-h) * 2 - 2.5*var(--border-size));
}

.speech-bubble.pop{
  animation-name: pop;
  animation-duration: 0.5s;
  animation-timing-function:cubic-bezier(0.755, 0.050, 0.855, 0.060);
}

.speech-bubble.float{
  animation-name: float-up;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function:ease;
}

.speech-bubble.r.float{
  animation-name: float-left;
}

.speech-bubble.l.float{
  animation-name: float-right;
}

.speech-bubble.t.float{
  animation-name: float-down;
}

@keyframes pop {
  0% {transform: scale(0.8);}
  80% {transform: scale(1.1);}
  90% {transform: scale(0.9);}
  100% {transform: scale(1);}
}

@keyframes float-up {
  0% {transform: translateY(0);}
  50% {transform: translateY(calc(-1 * var(--arrow-h)));}
}

@keyframes float-left {
  0% {transform: translateX(0);}
  50% {transform: translateX(calc(-1 * var(--arrow-h)));}
}

@keyframes float-right {
  0% {transform: translateX(0);}
  50% {transform: translateX(var(--arrow-h));}
}

@keyframes float-down {
  0% {transform: translateY(0);}
  50% {transform: translateY(var(--arrow-h));}
}

</style>
